// extracted by mini-css-extract-plugin
export default {"real-time_chat-container":"realTimeChat_real-time_chat-container__EnX3K","real-time_chat":"realTimeChat_real-time_chat__a1UYO"};